import React, { useContext, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import CookieFunction from '../../functions/cookieFunction';

export default function BackgroundProgressBar({ content, extraClassName }) {
  const { backScale, setBackScale } = useContext(AdminContext);
  const changeProggress = () => {
    console.log('inputvalue', document.getElementById('backInput').value);
    let x = document.getElementById('backInput').value;
    CookieFunction('set', 'backScale', x, () => {
      setBackScale(CookieFunction('get', 'backScale'));
    });
  };
  return (
    <div className={`flex flex-row justify-start items-center w-full h-auto `}>
      <input
        id={`backInput`}
        type="range"
        onChange={() => changeProggress()}
        className={` ${extraClassName ? extraClassName : 'e-range'} `}
        value={backScale}
        // value={
        //   document.getElementById('hiddenAudio')?.currentTime
        //     ? seekValue
        //     : 0
        // }
        // value={0}
      />
    </div>
  );
}
